import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'fountain',
      d: 'M-1,-2.5h2v0.5h-2zM-0.5,-2h0.5v1.5h-0.5zM-3.5,-0.5h0.5v0.5h-0.5zM-0.5,-0.5h1v0.5h-1zM3,-0.5h0.5v0.5h-0.5zM-3.5,0h1.5v0.5h-1.5zM2,0h0.5v0.5h-0.5zM-3,0.5h3.5v0.5h-3.5zM-2,1h2.5v0.5h-2.5z',
    },
    {
      paint: 'rock',
      d: 'M0,-2h0.5v1.5h-0.5zM2.5,0h1v0.5h-1zM0.5,0.5h2.5v0.5h-2.5zM0.5,1h2v0.5h-2z',
    },
    {
      paint: 'snowCap',
      d: 'M-1.5,-3.5h0.5v0.5h-0.5zM-0.5,-3.5h0.5v0.5h-0.5zM1,-3.5h0.5v0.5h-0.5zM-1,-3h1.5v0.5h-1.5zM-1,-2h0.5v0.5h-0.5zM0.5,-2h0.5v0.5h-0.5zM-3,-1.5h2.5v0.5h-2.5zM1,-1.5h2v0.5h-2zM-3.5,-1h1v0.5h-1zM2.5,-1h1v0.5h-1zM-3,-0.5h1v0.5h-1zM2,-0.5h1v0.5h-1zM-2,0h4v0.5h-4z',
    },
    {
      paint: 'frozenWater',
      d: 'M0,-3.5h0.5v0.5h-0.5zM-2.5,-1h1v0.5h-1zM2,-1h0.5v0.5h-0.5zM1.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'ice',
      d: 'M-1,-3.5h0.5v0.5h-0.5zM0.5,-3.5h0.5v0.5h-0.5zM-1.5,-1h1v0.5h-1zM0.5,-1h1.5v0.5h-1.5zM-2,-0.5h1.5v0.5h-1.5zM0.5,-0.5h1v0.5h-1z',
    },
    {
      paint: 'icicle',
      d: 'M0,-4.5h0.5v0.5h-0.5zM-0.5,-4h1v0.5h-1zM-1.5,-3h0.5v1.5h-0.5zM0.5,-3h1v0.5h-1zM0.5,-1.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 100,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'fountain',
      d: 'M-1,-2.5h0.5v0.5h-0.5zM0,-2.5h0.5v0.5h-0.5zM-0.5,-1.5h0.5v1h-0.5zM-3.5,-0.5h0.5v0.5h-0.5zM-0.5,-0.5h1v0.5h-1zM3,-0.5h0.5v0.5h-0.5zM-3.5,0h1v0.5h-1zM-3,0.5h3.5v0.5h-3.5zM-2,1h2.5v0.5h-2.5z',
    },
    {
      paint: 'rock',
      d: 'M0,-2h0.5v1.5h-0.5zM2.5,0h1v0.5h-1zM0.5,0.5h2.5v0.5h-2.5zM0.5,1h2v0.5h-2z',
    },
    {
      paint: 'snowCap',
      d: 'M-1.5,-3.5h0.5v0.5h-0.5zM1,-3.5h0.5v0.5h-0.5zM-1,-2h0.5v0.5h-0.5zM-3,-1.5h2.5v0.5h-2.5zM1,-1.5h2v0.5h-2zM-3.5,-1h1v0.5h-1zM2.5,-1h1v0.5h-1zM-3,-0.5h1v0.5h-1zM2,-0.5h1v0.5h-1zM-2,0h4v0.5h-4z',
    },
    {
      paint: 'frozenWater',
      d: 'M0,-5h0.5v0.5h-0.5zM0.5,-4.5h0.5v1h-0.5zM0,-3.5h0.5v1h-0.5zM0.5,-2.5h1v0.5h-1zM0.5,-2h0.5v0.5h-0.5zM-2.5,-1h1v0.5h-1zM2,-1h0.5v0.5h-0.5zM1.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'ice',
      d: 'M-1.5,-1h1v0.5h-1zM0.5,-1h1.5v0.5h-1.5zM-2,-0.5h1.5v0.5h-1.5zM0.5,-0.5h1v0.5h-1z',
    },
    {
      paint: 'icicle',
      d: 'M-1,-4.5h1.5v1h-1.5zM-1,-3.5h1v0.5h-1zM0.5,-3.5h0.5v0.5h-0.5zM-1.5,-3h1.5v0.5h-1.5zM0.5,-3h1v0.5h-1zM-1.5,-2.5h0.5v1h-0.5zM-0.5,-2.5h0.5v1h-0.5zM0.5,-1.5h0.5v0.5h-0.5z',
    },
    { paint: 'icicleBlue', d: 'M-2.5,0h0.5v0.5h-0.5zM2,0h0.5v0.5h-0.5z' },
  ],
  pixels: 107,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant0];
